// extracted by mini-css-extract-plugin
module.exports = {"comp":"AU6_comp__4TUhp"};